// extracted by mini-css-extract-plugin
export default {"platformCell":"z5PV9LVohPzGRIg_hHkz","clearAllButtonCell":"JHwO44j4cxOAUtZSd7ja"};